import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const employerPreferences = generateEntityCrudActionTypes('employerPreferences')

export default { ...employerPreferences }
